export function formatDate(substr: string) {
  if (substr.length !== 6) return undefined;
  if (!/^\d{6}$/.test(substr)) return undefined;

  const toInt = (s: string) => Number.parseInt(s, 10);
  const isMonth = (m: number) => m >= 1 && m <= 12;

  // Format A (GS1 EXP common): YYMMDD → we return YYYY-MM
  const yy = substr.substring(0, 2);
  const mmA = substr.substring(2, 4);
  const monthA = toInt(mmA);

  // Format B: MMYYYY → we return YYYY-MM
  const mmB = substr.substring(0, 2);
  const yyyyB = substr.substring(2, 6);
  const monthB = toInt(mmB);
  const yearB = toInt(yyyyB);

  const looksLikeMMYYYY = isMonth(monthB) && yearB >= 1900 && yearB <= 2099;
  if (looksLikeMMYYYY) return `${yyyyB}-${mmB}`;

  // Fall back to YYMMDD if month is valid
  if (!isMonth(monthA)) return undefined;
  return `20${yy}-${mmA}`;
}
